/* eslint-disable consistent-return */
import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { ROUTE_NAMES } from '~/scopes/dashboard/constants'

// Matches /:locale/dashboard/orders/:orderlinePublicId/track& (trailing & after /track)
// Example: /fr-fr/dashboard/orders/abc123/track&
const TRACK_PARCEL_UNRESOLVED_PATH_RE =
  /^\/([^/]+)\/dashboard\/orders\/([^/]+)\/track(&.*)$/

/*
 * Temporary fix for incident https://imperatorz.slack.com/archives/C0C04DJ90V8/p1788798740715739
 */
export default defineNuxtRouteMiddleware((to) => {
  // Case B: route is not resolved (to.matched is empty, to.name is undefined)
  // because the & sits in the path segment itself: /track&
  const match = TRACK_PARCEL_UNRESOLVED_PATH_RE.exec(to.path)

  if (!match) return

  const locale = match[1]
  const orderlinePublicId = match[2]

  return navigateTo(
    {
      name: ROUTE_NAMES.DASHBOARD.MY_ORDERS.TRACK_PARCEL,
      params: { locale, orderlinePublicId },
      query: to.query,
    },
    { replace: true },
  )
})
